export function getGroupPath(companySlug: string, groupId: string) {
    return `/${companySlug}/groups/${groupId}`;
}
